import { render, staticRenderFns } from "./envImpactAssessment.vue?vue&type=template&id=5854a34a"
import script from "./envImpactAssessment.vue?vue&type=script&lang=js"
export * from "./envImpactAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5854a34a')) {
      api.createRecord('5854a34a', component.options)
    } else {
      api.reload('5854a34a', component.options)
    }
    module.hot.accept("./envImpactAssessment.vue?vue&type=template&id=5854a34a", function () {
      api.rerender('5854a34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/eia/envImpactAssessment.vue"
export default component.exports